"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var moment = require("moment");

var LockInfo_1 = require("../model/LockInfo");

var LockInfoConverter_1 = require("./LockInfoConverter");
/**
 * Workflow case info converter.
 *
 * @author VBr
 */


var LockInfoConverterImpl =
/*#__PURE__*/
function (_LockInfoConverter_1$) {
  _inherits(LockInfoConverterImpl, _LockInfoConverter_1$);

  function LockInfoConverterImpl() {
    _classCallCheck(this, LockInfoConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(LockInfoConverterImpl).apply(this, arguments));
  }

  _createClass(LockInfoConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      return new LockInfo_1.LockInfo(source.id, source.tag, source.resourceType, source.resourceId, moment(source.issued), source.cases, source.issuers);
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      return {
        id: source.id,
        tag: source.tag,
        resourceType: source.resourceType,
        resourceId: source.resourceId,
        issued: source.issued,
        cases: source.cases,
        issuers: source.issuers
      };
    }
  }]);

  return LockInfoConverterImpl;
}(LockInfoConverter_1.LockInfoConverter);

exports.LockInfoConverterImpl = LockInfoConverterImpl;